import type { Comp, GameObj, PosComp } from "kaplay";
import { config } from "../config";
import { GAME_H, PLAYER_SCREEN_Y, TOUCH_ZOOM, ZOOM_MAX, ZOOM_MIN } from "../config/constants";
import { k } from "../core/kaplay";
import { isTouchDevice } from "../core/settings";
import { viewport } from "../core/viewport";
import type { RiderComp } from "./rider";

const ZOOM_EASE_PER_S = 2;

export function cameraFollow(): Comp {
    const deviceZoom = isTouchDevice() ? TOUCH_ZOOM : 1;
    let zoom = ZOOM_MAX;
    return {
        id: "cameraFollow",
        require: ["pos", "rider"],
        update(this: GameObj<PosComp | RiderComp>) {
            const speedFraction = Math.min(1, this.motion.speed / config.player.maxSpeed);
            const target = (ZOOM_MAX + (ZOOM_MIN - ZOOM_MAX) * speedFraction) * deviceZoom;
            zoom += (target - zoom) * Math.min(1, ZOOM_EASE_PER_S * k.dt());

            const visibleHeight = GAME_H / zoom;
            k.setCamScale(viewport.uiScale * zoom);
            k.setCamPos(this.pos.x, this.pos.y + (0.5 - PLAYER_SCREEN_Y) * visibleHeight);
        },
    };
}
